import { render, staticRenderFns } from "./pod.vue?vue&type=template&id=1ef0e3dd&scoped=true&"
import script from "./pod.vue?vue&type=script&lang=js&"
export * from "./pod.vue?vue&type=script&lang=js&"
import style0 from "./pod.vue?vue&type=style&index=0&id=1ef0e3dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef0e3dd",
  null
  
)

export default component.exports